import { atomWithRefresh } from "../utils";

export interface TablesApiResponse {
  tableCount: number;
  maxTableCount: number;
  maxRecordsCount: number;
  needsToUpgrade: boolean;
}

export const tablesUsageAtom_SUSPENDS = atomWithRefresh<
  Promise<TablesApiResponse | null>
>(async () => {
  try {
    const res = await fetch(`/api/canvasui/tables`);

    if (!res.ok) {
      return null;
    }

    const json: TablesApiResponse = await res.json();
    return json;
  } catch (error) {
    return null;
  }
});

tablesUsageAtom_SUSPENDS.debugLabel = "tablesUsageAtom_SUSPENDS";
